module.exports = __webpack_public_path__ + "f1df71adf1c8175f64865a4a5de4320e.otf";